module.exports = __webpack_public_path__ + "static/img/btn-zizhuji-success.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/btn-zizhuji-success.png
// module id = 525
// module chunks = 0